export default __webpack_public_path__ + "static/media/ae-icon-loading.a5ebdcf3.png";